import React, { useContext } from "react";

import { WebsiteContext } from "../../hoc/Layout";
import websiteLogo from "../../assets/images/pixelatedlogo.png";
import classes from "./Logo.module.css";

export const Logo = props => {
  const websiteContext = useContext(WebsiteContext);
  // Full navigation to the site root (the static portfolio), not a client-side route.
  return (
    <a className={classes.LogoAnchor} href="/">
      <img
        className={classes.Logo}
        src={websiteLogo}
        alt="Overwatch Pixel Mixer"
      />
      {websiteContext.siteName}
    </a>
  );
};
